import { makeAutoObservable } from 'mobx';

import { resetAllStore } from '../../shared/stores/resetAllStore';
import { FilterStore } from '../../shared/util-stores';
import { HandleGetDataReturn } from '../../shared/util-stores/FilterStore/FilterStore';
import { SpringFiltration } from '../../shared/interfaces/SpringFiltration';
import { FOOD_TYPE, FoodType } from '../constants/foodType';
import { FoodListItem } from '../interfaces/FoodListItem';
import { FoodsFilterData } from '../interfaces/FoodsFilters';
import { foodsService } from '../services/foodsService';

const defaultFilterData: FoodsFilterData = { name: '', brand: '' };

class FoodsListStore {
  private readonly foodType: FoodType;
  foodsList: FoodListItem[] = [];
  filterMethods: FilterStore<FoodsFilterData>;

  constructor(foodType: FoodType) {
    makeAutoObservable(this, {}, { autoBind: true });

    this.foodType = foodType;
    this.filterMethods = new FilterStore<FoodsFilterData>(this.handleGetFoods, {
      defaultFilterData,
    });
  }

  setDefaultValues() {
    this.foodsList = [];
    this.filterMethods.setDefaultValues();
  }

  private async handleGetFoods(
    filterInfo: SpringFiltration<FoodsFilterData>,
  ): Promise<HandleGetDataReturn> {
    const data = await foodsService.getFoods(this.foodType, filterInfo);
    const { foods, totalPages, totalElements, page } = data;

    this.setFoodsList(foods);

    return {
      content: foods,
      totalPages,
      number: page,
      totalElements,
    };
  }

  async getFoodsList() {
    return this.filterMethods.getData();
  }

  async changeFoodState(foodId: number, ban: boolean) {
    await foodsService.changeFoodState(foodId, ban);
    await this.filterMethods.getData();
  }

  async deleteFood(foodId: number) {
    await foodsService.deleteFood(foodId);
    await this.filterMethods.getData();
  }

  private setFoodsList(foodsList: FoodListItem[]) {
    this.foodsList = foodsList;
  }
}

// instance per food type so a late response can only land in the store that asked for it,
// and each type keeps its own filters/page
const coreFoodsListStore = new FoodsListStore(FOOD_TYPE.CORE);
const supplementFoodsListStore = new FoodsListStore(FOOD_TYPE.SUPPLEMENT);
const veggiesFoodsListStore = new FoodsListStore(FOOD_TYPE.VEGGIES);
const barcodeFoodsListStore = new FoodsListStore(FOOD_TYPE.BARCODE);

resetAllStore.addResetMethod(coreFoodsListStore.setDefaultValues);
resetAllStore.addResetMethod(supplementFoodsListStore.setDefaultValues);
resetAllStore.addResetMethod(veggiesFoodsListStore.setDefaultValues);
resetAllStore.addResetMethod(barcodeFoodsListStore.setDefaultValues);

export {
  coreFoodsListStore,
  supplementFoodsListStore,
  veggiesFoodsListStore,
  barcodeFoodsListStore,
  FoodsListStore,
};
